const styles = theme => ({
  page: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  pageHeader: {
    marginBottom: 50,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      // Adjust margin-bottom for smaller screens
      marginBottom: 20,
    },
  },
  ourDiv: {
    backgroundColor: '#015FFB',
    borderRadius: '16px',
    width: '60px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 10,
  },
  contentDiv: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: 1000,
    height: 300,
    [theme.breakpoints.down('sm')]: {
      // Add media query here
      flexDirection: 'column',
      width: '100%',
      height: 'auto',
      backgroundColor: '#F4F6F8',
      borderRadius: '16px',
    },
  },
  contentDivItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: 440,
    padding: 70,
    [theme.breakpoints.down('sm')]: {
      // Adjust padding for smaller screens
      width: '100%',
      padding: 20,
    },
  },
  logos: {
    width: '154px',
    marginBottom: 50,
    [theme.breakpoints.down('sm')]: {
      // Adjust logo size for smaller screens
      width: '120px',
      marginBottom: 30,
    },
  },
  mb: {
    marginBottom: 50,
    [theme.breakpoints.down('sm')]: {
      // Adjust margin-bottom for smaller screens
      marginBottom: 30,
    },
  },
  buttons: {
    color: '#015FFB',
    borderRadius: 50,
    boxShadow: 'none',
    width: '50%',
    [theme.breakpoints.down('sm')]: {
      // Adjust button width for smaller screens
      width: '80%',
    },
  },
})

export default styles
